import { render, staticRenderFns } from "./RegistriesItemEdit.vue?vue&type=template&id=7773e640&"
import script from "./RegistriesItemEdit.vue?vue&type=script&lang=js&"
export * from "./RegistriesItemEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports